export const CHANGE_USER = 'CHANGE_USER';